<template>
  <div class="layerWrapper active" style="display: block;" tabindex="0">
    <div class="cbox layerBox popWidM" ref="layerBox"
      :style="{'display': 'block', 'opacity': '1', ...style}">
      <div class="cart-popup__dialog NCAcmi_cont02_popUp">
        <div class="cart-popup__content payment">
          <div class="cart-popup__item-info amway-theme" style="padding:0;">
            <template v-if="isVip">
              <div class="os_noticeRes">
                <div class="widS">
                  <img src="@/views/survey2/images/activity/active_vip_01.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <h3>2&amp;3&amp;4 일차 선택 프로그램</h3>
                  <dl>
                    <dt>선택 프로그램 01</dt>
                    <dd>짚라인 액티비티</dd>
                    <dd>소요시간 | 약 4시간 30분, 제한인원 | 130명, 차량 이동시간 | 1시간</dd>
                  </dl>
                  <p>자연 속 스릴 만점 액티비티</p>
                  <span>짚라인 액티비티는 치앙마이에서 빼놓을 수 없는 액티비티 중 하나입니다! 짧고 긴 코스가 다양하게 구성된 짚라인 코스 중에는 외줄타기, 사다리 건너기와 같은 코스도 포함돼
                    있습니다. 스릴 넘치고 짜릿한 액티비티를 즐기고 싶으시다면 짚라인 액티비티를 강력 추천 드립니다!</span>
                  <ul>
                    <li>제한 연령: 만6세 ~ 만 65세</li>
                    <li>제한 대상: 체중 120kg 이상, 신장 120cm 이하, 고소공포증 환자, 심신미약자, 임산부</li>
                    <li>주의 사항: 음주 및 약물 복용 금지, 귀중품 소지 금지</li>
                    <li>준비물: 편한복장, 운동화</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_vip_02.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 02</dt>
                    <dd>래프팅 액티비티</dd>
                    <dd>소요시간 | 7시간, 제한인원 | 60명, 차량 이동시간 | 2시간</dd>
                  </dl>
                  <p>매땡강에서 즐기는 짜릿한 래프팅</p>
                  <span>온몸으로 치앙마이의 자연을 만끽해보세요! 치앙마이 북동부에 흐르는 매땡강은 급류가 발달하고 자연경관이 수려하여 래프팅으로 인기가 많습니다. 온몸으로 직접 급류를 느끼며
                    즐거운 추억을 만들어 보세요!</span>
                  <ul>
                    <li>제한 연령: 만8세 ~ 만 70세</li>
                    <li>제한 대상: 체중 120kg 이상, 심신 미약자, 물 공포증, 임산부</li>
                    <li>주의 사항: 음주 및 약물 복용 금지, 귀중품 소지 금지</li>
                    <li>준비물: 물에 젖어도 되는 옷 및 신발, 갈아입을 옷 및 신발</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_vip_03.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 03</dt>
                    <dd>몬쨈 글램핑</dd>
                    <dd>소요시간 | 약 6시간 30분, 제한인원 | 50명, 차량 이동시간 | 1시간 30분</dd>
                  </dl>
                  <p>치앙마이에서 만나는 힐링 가득 몬쨈 글램핑</p>
                  <span>치앙마이 시내에서 벗어나 조용하고 한가롭게 여유를 즐겨 보세요! 몬쨈은 치앙마이 매림 지역에서 가장 유명한 관광지로 태국인들이 즐겨 찾는 지역 중 한 곳입니다. 독특하게
                    생긴 텐트에서 태국식 샤브샤브인 '무카타'와 과일을 드시면서 여유롭게 휴식을 취하실 수 있습니다. 지친 일상 속, 잠시 쉼이 필요하신 분들에게 추천 드립니다.</span>
                  <ul>
                    <li>준비물: 따뜻한 옷(바람막이 외투 등)</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_vip_04.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 04</dt>
                    <dd>매땡 코끼리 캠프</dd>
                    <dd>소요시간 | 6시간, 제한인원 | 90명, 차량 이동시간 | 1시간 30분</dd>
                  </dl>
                  <p>태국 코끼리와 함께하는 교감과 공존의 시간</p>
                  <span>매땡 코끼리 캠프는 단순히 코끼리 관광을 위한 곳이 아닌 코끼리를 지켜주며 치료해주는 보호 시설이기도 합니다. 매땡 코끼리 캠프에서는 코끼리에 올라타 코끼리 트래킹을
                    즐기실 수 있으며 다재다능한 코끼리 쇼도 관람할 수 있습니다. 그리고 전통 생활방식을 고수하며 살아가는 고산족 마을 투어도 함께 즐기실 수 있습니다.</span>
                  <ul>
                    <li>주의 사항: 본인의 책임아래 아동 및 유아, 노약자 코끼리 트랙킹 체험 가능</li>
                    <li>준비물: 편한 복장, 운동화</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_vip_05.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 05</dt>
                    <dd>도이 인타논</dd>
                    <dd>소요시간 | 8시간, 제한인원 | 130명, 차량 이동시간 | 1시간 30분</dd>
                  </dl>
                  <p>치앙마이의 자연을 만나다</p>
                  <span>아름다운 자연경관으로 유명한 도이 인타논 국립공원에서 태국 자연 환경의 신비함과 놀라운 절경을 만나보세요! 도이 인타논 트래킹 코스를 걷다 보면 영화 '아바타'의 배경이
                    되었던 울창한 숲을 만나 보실 수 있습니다. 그리고 왕과 왕비의 장수를 기념하는 '국왕과 왕비의 탑'을 구경하며 아름다운 정원을 관람할 수 있습니다. 마지막으로 도이 인타논
                    국립공원에서 가장 큰 폭포인 '왓치 라탄 폭포'를 만나보실 수 있습니다.</span>
                  <ul>
                    <li>주의 사항: 민소매 티셔츠, 치마, 짧은 반바지 착용자 '국왕과 왕비의 탑'출입 불가</li>
                    <li>준비물: 따뜻한 옷(바람막이, 외투 등), 운동화</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_vip_06.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 06</dt>
                    <dd>도이수텝 &amp; 올드시티</dd>
                    <dd>소요시간 | 5시간 30분, 제한인원 | 100명, 차량 이동시간 | 1시간</dd>
                  </dl>
                  <p>치앙마이의 역사를 돌아보는 대표 관광코스</p>
                  <span>치앙마이 대표 관광지와 란나 왕국 역사의 숨결을 만나보세요! 도이수텝은 전 세계 수많은 관광객의 발길을 이끌고 있는 치앙마이 대표 관광지로 치앙마이 여행에서 꼭 가봐야
                    할 명소 중 하나입니다. 올드시티 투어는 라나 왕국의 수도였던 치앙마이를 돌아보는 투어로, 란나 왕조의 역사를 곳곳에서 느끼실 수 있습니다.</span>
                  <ul>
                    <li>주의 사항: 민소매 티셔츠, 치마, 짧은 반바지 착용자 사원 출입 불가</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_vip_07.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 07</dt>
                    <dd>반캉왓 민예마을 &amp; 왓우몽 사원</dd>
                    <dd>소요시간 | 4시간, 제한인원 | 50명, 차량 이동시간 | 30분</dd>
                  </dl>
                  <p>치앙마이에서 만나는 예술인 마을과 도심 속 사원</p>
                  <span>반캉왓 민예마을은 예술인 공동체 마을로 마을을 둘러보며 치앙마이 지역 예술가의 작품과 수공예품을 만나보실 수 있습니다. 왓우몽 사원은 고요함 속에서 명상을 하려는
                    불자들이 모이는 곳으로 유명합니다. 사원과 큰 호수를 둘러보며 여유를 만끽해보시기를 바랍니다.</span>
                  <ul>
                    <li>주의 사항: 민소매 티셔츠, 치마, 짧은 반바지 착용자 사원 출입 불가</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_vip_08.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 08</dt>
                    <dd>마사지 &amp; 쇼핑몰</dd>
                    <dd>소요시간 | 5시간, 제한인원 | 50명, 차량 이동시간 | 30분</dd>
                  </dl>
                  <p>태국 마사지 체험과 원님만 몰 쇼핑</p>
                  <span>여행의 피로도 풀고 쇼핑도 함께 즐겨보세요! 태국 하면 제일 먼저 떠오르는 마사지! 태국 마사지를 통해 여행의 피로를 풀어보세요. 그리고 최근 치앙마이 핫플레이스로
                    주목받는 쇼핑몰 중 하나인 원님만 몰을 방문하여 다양한 상점과 푸드코트를 둘러볼 수 있습니다.</span>
                  <ul>
                    <li>제한 연령: 만 15세 이상</li>
                    <li>점심 식사: 불포함(자율 중식비 제공)</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_vip_09.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 09</dt>
                    <dd>호텔 휴식</dd>
                    <dd>SHANGRI-LA HOTEL CHIANG MAI</dd>
                  </dl>
                  <p>치앙마이 최고의 호텔에서 즐기는 호캉스</p>
                  <span>치앙마이 5성급 럭셔리 호텔인 샹그릴라 호텔 치앙마이에서 나만을 위한 호캉스를 즐겨보세요! 넓은 수영장과 피트니스 센터 이용 이외에도 Amway 리더님만을 위한
                    액티비티가 준비되어 있습니다.</span>
                </div>

                  <img src="@/views/survey2/images/activity/active_vip_10.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <h2>VIP 선택 프로그램</h2>
                  <dl>
                    <dt>골프</dt>
                    <dd>GREEN VALLEY GOLF CLUB</dd>
                  </dl>
                  <p>치앙마이 최고 컨디션을 자랑하는 골프클럽</p>
                  <span>그랜밸리 골프클럽은 미국의 Associates Inc.와 Dennis Griffths가 설계한 18홀 규모의 골프장으로 조니워커 골프 대회와 같은 국제 대회가 열리는
                    골프장입니다. 그린밸리 골프 클럽에서 아름다운 자연경관을 만끽하며 라운딩을 즐겨보세요.</span>
                </div>

                  <img src="@/views/survey2/images/activity/active_vip_11.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>스파</dt>
                    <dd>SHANGRI-LA HOTEL CHIANG MAI, CHI, THE SPA</dd>
                  </dl>
                  <p>치앙마이 샹그릴라 호텔 CHI, The SPA</p>
                  <span>호텔 내 고요한 연꽃 연못과 정원으로 둘러싸인 CHI, The SPA에서 편안한 휴식을 취하실 수 있습니다. 호텔에 머무르시면서, 치앙마이 최고의 마사지를
                    받아보세요!</span>
                  <ul>
                    <li>제한 연령: 만 15세 이상</li>
                  </ul>
                </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="os_noticeRes">
                <div class="widS">
                  <img src="@/views/survey2/images/activity/active_01.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <h3>2&amp;3&amp;4 일차 선택 프로그램</h3>
                  <dl>
                    <dt>선택 프로그램 01</dt>
                    <dd>짚라인 액티비티</dd>
                    <dd>소요시간 | 약 4시간 30분, 제한인원 | 130명, 차량 이동시간 | 1시간</dd>
                  </dl>
                  <p>자연 속 스릴 만점 액티비티</p>
                  <span>짚라인 액티비티는 치앙마이에서 빼놓을 수 없는 액티비티 중 하나입니다! 짧고 긴 코스가 다양하게 구성된 짚라인 코스 중에는 외줄타기, 사다리 건너기와 같은 코스도 포함돼
                    있습니다. 스릴 넘치고 짜릿한
                    액티비티를 즐기고 싶으시다면 짚라인 액티비티를 강력 추천 드립니다!</span>
                  <ul>
                    <li>제한 연령: 만6세 ~ 만 65세</li>
                    <li>제한 대상: 체중 120kg 이상, 신장 120cm 이하, 고소공포증 환자, 심신미약자, 임산부</li>
                    <li>주의 사항: 음주 및 약물 복용 금지, 귀중품 소지 금지</li>
                    <li>준비물: 편한복장, 운동화</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_02.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 02</dt>
                    <dd>래프팅 액티비티</dd>
                    <dd>소요시간 | 7시간, 제한인원 | 60명, 차량 이동시간 | 2시간</dd>
                  </dl>
                  <p>매땡강에서 즐기는 짜릿한 래프팅</p>
                  <span>온몸으로 치앙마이의 자연을 만끽해보세요! 치앙마이 북동부에 흐르는 매땡강은 급류가 발달하고 자연경관이 수려하여 래프팅으로 인기가 많습니다. 온몸으로 직접 급류를 느끼며
                    즐거운 추억을 만들어
                    보세요!</span>
                  <ul>
                    <li>제한 연령: 만8세 ~ 만 70세</li>
                    <li>제한 대상: 체중 120kg 이상, 심신 미약자, 물 공포증, 임산부</li>
                    <li>주의 사항: 음주 및 약물 복용 금지, 귀중품 소지 금지</li>
                    <li>준비물: 물에 젖어도 되는 옷 및 신발, 갈아입을 옷 및 신발</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_03.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 03</dt>
                    <dd>몬쨈 글램핑</dd>
                    <dd>소요시간 | 약 6시간 30분, 제한인원 | 50명, 차량 이동시간 | 1시간 30분</dd>
                  </dl>
                  <p>치앙마이에서 만나는 힐링 가득 몬쨈 글램핑</p>
                  <span>치앙마이 시내에서 벗어나 조용하고 한가롭게 여유를 즐겨 보세요! 몬쨈은 치앙마이 매림 지역에서 가장 유명한 관광지로 태국인들이 즐겨 찾는 지역 중 한 곳입니다. 독특하게
                    생긴 텐트에서 태국식 샤브샤브인
                    '무카타'와 과일을 드시면서 여유롭게 휴식을 취하실 수 있습니다. 지친 일상 속, 잠시 쉼이 필요하신 분들에게 추천 드립니다.</span>
                  <ul>
                    <li>준비물: 따뜻한 옷(바람막이, 외투 등)</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_04.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 04</dt>
                    <dd>매땡 코끼리 캠프</dd>
                    <dd>소요시간 | 6시간, 제한인원 | 90명, 차량 이동시간 | 1시간 30분</dd>
                  </dl>
                  <p>태국 코끼리와 함께하는 교감과 공존의 시간</p>
                  <span>매땡 코끼리 캠프는 단순히 코끼리 관광을 위한 곳이 아닌 코끼리를 지켜주며 치료해주는 보호 시설이기도 합니다. 매땡 코끼리 캠프에서는 코끼리에 올라타 코끼리 트래킹을
                    즐기실 수 있으며 다재다능한 코끼리
                    쇼도 관람할 수 있습니다. 그리고 전통 생활방식을 고수하며 살아가는 고산족 마을 투어도 함께 즐기실 수 있습니다.</span>
                  <ul>
                    <li>주의 사항: 본인의 책임아래 아동 및 유아, 노약자 코끼리 트랙킹 체험 가능</li>
                    <li>준비물: 편한 복장, 운동화</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_05.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 05</dt>
                    <dd>도이 인타논</dd>
                    <dd>소요시간 | 8시간, 제한인원 | 130명, 차량 이동시간 | 1시간 30분</dd>
                  </dl>
                  <p>치앙마이의 자연을 만나다</p>
                  <span>아름다운 자연경관으로 유명한 도이 인타논 국립공원에서 태국 자연 환경의 신비함과 놀라운 절경을 만나보세요! 도이 인타논 트래킹 코스를 걷다 보면 영화 '아바타'의 배경이
                    되었던 울창한 숲을 만나 보실
                    수 있습니다. 그리고 왕과 왕비의 장수를 기념하는 '국왕과 왕비의 탑'을 구경하며 아름다운 정원을 관람할 수 있습니다. 마지막으로 도이 인타논 국립공원에서 가장 큰 폭포인
                    '왓치 라탄 폭포'를 만나보실 수
                    있습니다.</span>
                  <ul>
                    <li>주의 사항: 민소매 티셔츠, 치마, 짧은 반바지 착용자 '국왕과 왕비의 탑'출입 불가</li>
                    <li>준비물: 따뜻한 옷(바람막이, 외투 등), 운동화</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_06.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 06</dt>
                    <dd>도이수텝 &amp; 올드시티</dd>
                    <dd>소요시간 | 5시간 30분, 제한인원 | 100명, 차량 이동시간 | 1시간</dd>
                  </dl>
                  <p>치앙마이의 역사를 돌아보는 대표 관광코스</p>
                  <span>치앙마이 대표 관광지와 란나 왕국 역사의 숨결을 만나보세요! 도이수텝은 전 세계 수많은 관광객의 발길을 이끌고 있는 치앙마이 대표 관광지로 치앙마이 여행에서 꼭 가봐야
                    할 명소 중 하나입니다. 올드시티
                    투어는 라나 왕국의 수도였던 치앙마이를 돌아보는 투어로, 란나 왕조의 역사를 곳곳에서 느끼실 수 있습니다.</span>
                  <ul>
                    <li>주의 사항: 민소매 티셔츠, 치마, 짧은 반바지 착용자 사원 출입 불가</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_07.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 07</dt>
                    <dd>반캉왓 민예마을 &amp; 왓우몽 사원</dd>
                    <dd>소요시간 | 4시간, 제한인원 | 50명, 차량 이동시간 | 30분</dd>
                  </dl>
                  <p>치앙마이에서 만나는 예술인 마을과 도심 속 사원</p>
                  <span>반캉왓 민예마을은 예술인 공동체 마을로 마을을 둘러보며 치앙마이 지역 예술가의 작품과 수공예품을 만나보실 수 있습니다. 왓우몽 사원은 고요함 속에서 명상을 하려는
                    불자들이 모이는 곳으로 유명합니다.
                    사원과 큰 호수를 둘러보며 여유를 만끽해보시기를 바랍니다.</span>
                  <ul>
                    <li>주의 사항: 민소매 티셔츠, 치마, 짧은 반바지 착용자 사원 출입 불가</li>
                    <li>점심 식사: 포함</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_08.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 08</dt>
                    <dd>마사지 &amp; 쇼핑몰</dd>
                    <dd>소요시간 | 5시간, 제한인원 | 50명, 차량 이동시간 | 30분</dd>
                  </dl>
                  <p>태국 마사지 체험과 원님만 몰 쇼핑</p>
                  <span>여행의 피로도 풀고 쇼핑도 함께 즐겨보세요! 태국 하면 제일 먼저 떠오르는 마사지! 태국 마사지를 통해 여행의 피로를 풀어보세요. 그리고 최근 치앙마이 핫플레이스로
                    주목받는 쇼핑몰 중 하나인 원님만 몰을
                    방문하여 다양한 상점과 푸드코트를 둘러볼 수 있습니다.</span>
                  <ul>
                    <li>제한 연령: 만 15세 이상</li>
                    <li>점심 식사: 불포함(자율 중식비 제공)</li>
                  </ul>
                </div>

                  <img src="@/views/survey2/images/activity/active_09.jpg"
                  alt="액티비티 정보 안내">
                  <div class="hidden">
                  <dl>
                    <dt>선택 프로그램 09</dt>
                    <dd>호텔 휴식</dd>
                    <dd>SHANGRI-LA HOTEL CHIANG MAI</dd>
                  </dl>
                  <p>치앙마이 최고의 호텔에서 즐기는 호캉스</p>
                  <span>치앙마이 5성급 럭셔리 호텔인 샹그릴라 호텔 치앙마이에서 나만을 위한 호캉스를 즐겨보세요! 넓은 수영장과 피트니스 센터 이용 이외에도 Amway 리더님만을 위한
                    액티비티가 준비되어 있습니다.</span>
                </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div
          class="cart-popup__item-link" style="border:none;">
          <a @click="closePopup" class="bt-akl-blue btn_close NCAcmi_cont03_popup">확인</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SURVEY, TOGGLE_ACTIVITY_POPUP, IS_VIP } from '@/store/actions/survey'
import { PopupMixin } from '../mixins'

export default {
  name: 'SurveyPopupLayerActivity',
  mixins: [PopupMixin],
  computed: {
    ...mapState(SURVEY, {
      pinLevel: state => state.pin_level,
      show: state => state.popup_activity,
    }),
    ...mapGetters(SURVEY, {
      isVip: IS_VIP
    }),
  },
  watch: {
    show(isOpen) {
      if(isOpen) {
        this.htmlEl.classList.add("scrollLock");
        this.uiLayerMask.classList.add("on");
        this.uiLayerMask.style.display = 'block';
        window.addEventListener('resize', this.layerTypeBasic);
        this.layerTypeBasic();
      } else {
        this.htmlEl.classList.remove("scrollLock");
        this.uiLayerMask.classList.remove("on");
        this.uiLayerMask.style.display = 'none';
        window.removeEventListener('resize', this.layerTypeBasic);
      }
    }
  },
  methods: {
    closePopup() {
      this.$store.commit(`${SURVEY}/${TOGGLE_ACTIVITY_POPUP}`, false);
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey2/components/SurveyPopupLayerActivity.vue